import { Media } from "../media/media.type";
import { Menu, MenuItem, Section as MenuSection } from "./menu.type";

export interface MenuCombo {
  id: string;
  name: string;
  description?: string;
  price: number;
  isAvailable: boolean;
  sortOrder: number;
  menu: Menu;
  image?: Media;
  components: MenuComboComponent[];
}

export type MenuComboFormData = {
  name: string;
  description?: string;
  price: number;
  isAvailable?: boolean;
  sortOrder: number;
  menu: string;
  image?: string;
};

export interface MenuComboComponent {
  id: string;
  name: string;
  description?: string;
  quantity: number;
  menuCombo: string;
  menuSection?: MenuSection;
  includedMenuItems: MenuItem[];
  excludedMenuItems: MenuItem[];
  allowedSideTypes: string[];
  maxChoiceCount: number;
  isSubstitutable: boolean;
  isRequired: boolean;
  sortOrder: number;
}

export type MenuComboComponentFormData = {
  name: string;
  description?: string;
  quantity: number;
  menuCombo: string;
  menuSection?: string | null;
  includedMenuItems?: string[];
  excludedMenuItems?: string[];
  allowedSideTypes: string[];
  maxChoiceCount: number;
  isSubstitutable?: boolean;
  isRequired?: boolean;
  sortOrder: number;
};

export enum AllowedSideType {
  FRIES = "fries",
  SALADS = "salads",
}
